<template>
  <div>
      <div class="row">
          <div class="col-sm-12">
              <div class="page-title-box">
                  <div class="float-right">
                      <ol class="breadcrumb">
                          <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                          <li class="breadcrumb-item active">Laporan TBP</li>
                      </ol>
                  </div>
                  <h4 class="page-title">Laporan TBP</h4>
              </div>
          </div>
      </div>

      <div class="card card-loader d-flex" v-if="loading">
          <div class="justify-content-center">
              <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                  <span class="sr-only">Loading...</span>
              </div>
              <p class="mt-2">Loading</p>
          </div>
      </div>

      <div class="card" v-else>
          <div class="card-body">
              <div class="wrapper-table-default">
                  <div class="row mb-3">
                      <div class="col-12 col-md-4">
                          <date-picker required style="width: 100%" v-model="filter.date" :placeholder="'Dari - Sampai'"
                              format="DD/MM/YYYY" range></date-picker>
                      </div>
                      <div class="col-12 col-md-4">
                          <button class="btn btn-primary" @click="loadData">Filter</button>
                          <button class="btn btn-warning ml-3" @click="exportData">Export Data</button>
                      </div>
                  </div>
                  <div class="table-responsive" v-if="dataSummary">
                      <div class="row">
                          <div class="col-12 col-md-3">
                              <div class="card card-eco" style="border: 1px solid #ddd;">
                                  <div class="card-body" style="padding: 15px">
                                      <h4 class="title-text mt-0 mb-0">Jumlah Penetapan : {{dataSummary.details.jumlah_penetapan}}</h4>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-3">
                              <div class="card card-eco" style="border: 1px solid #ddd;">
                                  <div class="card-body" style="padding: 15px">
                                      <h4 class="title-text mt-0 mb-0">Jumlah Transaksi : {{dataSummary.details.jumlah_transaksi}}</h4>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-3">
                              <div class="card card-eco" style="border: 1px solid #ddd;">
                                  <div class="card-body" style="padding: 15px">
                                      <h4 class="title-text mt-0 mb-0">Total Penetapan : {{currency(dataSummary.details.total_penetapan)}}</h4>
                                  </div>
                              </div>
                          </div>
                          <div class="col-12 col-md-3">
                              <div class="card card-eco" style="border: 1px solid #ddd;">
                                  <div class="card-body" style="padding: 15px">
                                      <h4 class="title-text mt-0 mb-0">Total Transaksi : {{currency(dataSummary.details.total_transaksi)}}</h4>
                                  </div>
                              </div>
                          </div>
                      </div>
                      <table id="table-default" class="table table-hover with-action-last" cellspacing="0" width="100%">
                          <thead>
                              <tr>
                                  <th class="text-center">No Rekening</th>
                                  <th class="text-center">Nama</th>
                                  <th class="text-right">Penetapan</th>
                                  <th class="text-right">Realisasi</th>
                              </tr>
                          </thead>
                          <tbody>
                              <tr v-if="dataSummary.length <= 0">
                                  <td colspan="4" class="text-center">Data tidak ditemukan</td>
                              </tr>
                              <tr v-for="(item) in dataSummary.summaries" :key="item.id" v-else>
                                  <td>{{ item.code }}</td>
                                  <td class="text-center">{{ item.name ? item.name : 'Lainnya' }}</td>
                                  <td class="text-right">{{ currency(item.penetapan) }}</td>
                                  <td class="text-right">{{ currency(item.realisasi) }}</td>
                              </tr>
                          </tbody>
                      </table>
                  </div>
                  <div v-else>
                      <h2 class="text-center mt-5" style="font-size: 16px; background-color: #989898; padding: 7px; border-radius: 5px; color: #fff">Harap Memilih Periode Terlebih Dahulu</h2>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import moment from "moment"
import fileDownload from 'js-file-download'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

export default {
    data() {
        return {
            loading: true,
            loadingExport: false,

            filter: {
                company: null,
                date: [moment()._d, moment()._d],
                status: null,
            },

            allCompany: [],
            dataSummary: null,
        }
    },
    components: {
        DatePicker
    },
    methods: {
        convertPeriod(period) {
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Minggu'
            }else if(period == 'MONTHLY'){
                return 'Bulan'
            }else{
                return 'Tahun'
            }
        },
        async loadData() {
            if(this.filter.date[0] == null || this.filter.date[1] == null) {
                this.sAlert('error', 'Mohon memilih periode terlebih dahulu')
                return
            } 

            this.loading = true;
            try {
                let storedData = {
                    company_id: this.filter.company,
                    start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                    end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null
                }

                const summary = await this.$http.get(`${this.API_URL}summary-report?type=tbp`, 
                    {
                        params: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` 
                    }
                })
                this.dataSummary = summary.data.data

                setTimeout(() => {
                    this.dataTableSearch()
                }, 500);
                
                this.loading = false;
            } catch (error) {
                this.loading = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            }
        },
        async exportData() {
            this.loadingExport = true;

            var valueCode = null 
            await Swal.fire({
                input: 'text',
                inputPlaceholder: 'Masukkan No TBP',
                showCancelButton: true,
                confirmButtonText: 'Ya, Download!',
                html: `Masukkan No TBP`,
                inputValidator: (value) => {
                    valueCode = value
                }
            })
            .then(async (result) => {
                if (result.isConfirmed) {
                    this.sAlert('info', 'Sedang Mendownload ...')
                    console.log(valueCode);

                    let storedData = {
                        no_tbp: valueCode,
                        start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
                        end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
                        export: 1
                    }

                    const response = await this.$http.get(`${this.API_URL}summary-report?type=tbp`, {
                        responseType: 'blob',
                        params: storedData,
                        headers: { 
                            'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                        }
                    })

                    Swal.close()

                    fileDownload(response.data, 
                        `Laporan TBP${this.filter.date[0] ? '-' + moment(this.filter.date[0]).format('YYYY-MM-DD') : ''}${this.filter.date[1] ? '~' + moment(this.filter.date[1]).format('YYYY-MM-DD') : ''}.pdf`);
                    this.loadingExport = false   
                } else{
                    Swal.close()
                }
            })
            .catch(error => {
                console.log(error);
                this.loadingExport = false;
                this.sAlert('error', "Error, Terjadi Kesalahan!")
            });


            // try {
            //     this.loadingExport = true;
            //     this.sAlert('info', 'Sedang Mendownload ...')

            //     let storedData = {
            //         start_date: this.filter.date[0] ? moment(this.filter.date[0]).format('YYYY-MM-DD') : null,
            //         end_date: this.filter.date[1] ? moment(this.filter.date[1]).format('YYYY-MM-DD') : null,
            //         export: 1
            //     }

            //     const response = await this.$http.get(`${this.API_URL}summary-report?type=tbp`, {
            //         responseType: 'blob',
            //         params: storedData,
            //         headers: { 
            //             'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
            //         }
            //     })

            //     Swal.close()

            //     fileDownload(response.data, 
            //     `Laporan Tanda Bukti Transfer${this.filter.date[0] ? '-' + moment(this.filter.date[0]).format('YYYY-MM-DD') : ''}${this.filter.date[1] ? '~' + moment(this.filter.date[1]).format('YYYY-MM-DD') : ''}.pdf`);
            // this.loadingExport = false 
            // } catch (error) {
            //     console.log(error);
            //     this.loadingExport = false;
            //     this.sAlert('error', "Error, Terjadi Kesalahan!")
            // }
        },
        convertDate(date){
            return moment(date).format('DD MMMM YYYY')
        }
    },
    async mounted() {
        this.loading = true
        this.loadData()
        this.loading = false
    }
}
</script>